const LOCAL_STORAGE_CURRENT_LANGUAGE_KEY = 'LOCAL_STORAGE/I18N/CURRENT_LANGUAGE'

function setCurrentLanguage(currentLanguage) {
  if (currentLanguage === null) {
    localStorage.removeItem(LOCAL_STORAGE_CURRENT_LANGUAGE_KEY)
  } else {
    localStorage.setItem(LOCAL_STORAGE_CURRENT_LANGUAGE_KEY, currentLanguage)
  }
}

function getCurrentLanguage() {
  return localStorage.getItem(LOCAL_STORAGE_CURRENT_LANGUAGE_KEY)
}

export default {
  setCurrentLanguage,
  getCurrentLanguage
}
